export const SCHEMA_NAME = "ProblemFiles";

export const FIELDS = {
  PROBLEM_FILE_ID: "problemFileID",
  PROBLEM_CATEGORY: "problemCategory",
  PROBLEM_DESCRIPTION: "problemDescription",
  PROBLEM_STATUS: "problemStatus",
  COMMENTS: "comments",
  DATE_RESOLVED: "dateResolved",
  DATE_ADDED: "dateAdded",
  TIME_ADDED: "timeAdded",
  USER: "user",
  CREATOR_STAFF_ID: "creatorStaffID",
};
